import React from 'react';
import { X } from 'lucide-react';
import PhotoMap from './PhotoMap';

const MapModal = ({ photo, incident, distanceKm, onClose }) => {
  const heading = photo?.gps?.heading_deg;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="relative w-full max-w-4xl h-[80vh] bg-white dark:bg-gray-800 rounded-lg overflow-hidden shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-[1000] p-2 bg-white/90 dark:bg-gray-900/90 rounded-full text-gray-700 dark:text-gray-200 hover:bg-white"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="absolute top-3 left-3 z-[1000] bg-white/90 dark:bg-gray-900/90 px-3 py-2 rounded-md text-sm">
          {distanceKm !== undefined && distanceKm !== null ? (
            <span>Distância: <strong>{distanceKm.toFixed(2)} km</strong></span>
          ) : (
            <span className="text-gray-500">Distância indisponível</span>
          )}
          {heading !== undefined && heading !== null && (
            <span className="ml-3">Azimute: <strong>{Math.round(heading)}°</strong></span>
          )}
        </div>
        <PhotoMap photo={photo} incident={incident} distanceKm={distanceKm} />
      </div>
    </div>
  );
};

export default MapModal;
